/* eslint-disable no-useless-catch */
import axios from "axios";

export default {
  state: {
    nombre: "",
    fotoCatalogo: "",
    fotoPrincipal: "",
    fotos: []
  },
  mutations: {
    SET_PRODUCTO_NOMBRE: (state, payload) => {
      state.nombre = payload;
    },
    SET_FOTO_CATALOGO: (state, payload) => {
      state.fotoCatalogo = payload;
    },
    SET_FOTO_PRINCIPAL: (state, payload) => {
      state.fotoPrincipal = payload;
    },
    SET_GALERIA: (state, payload) => {
      state.fotos = payload;
    }
  },
  actions: {
    async getProductoGaleria({ rootState }, id) {
      try {
        const response = await axios.get(
          rootState.api.url + "producto-galeria?id=" + id
        );
        return response.data;
      } catch (e) {
        throw e;
      }
    },
    async deleteFotoGaleria({ rootState }, payload) {
      try {
        const response = await axios.delete(
          rootState.api.url + "delete-foto-galeria?id=" + payload.id
        );
        if (!response.data.status) {
          throw response.data.msg;
        }
        return response.data;
      } catch (e) {
        throw e;
      }
    }
  }
};
